<template>
  <div class="dokumen">
    <v-list three-line>
      <v-list-item v-for="(dok, id) in dokumens" :key="id" :class="['px-0', id === 0 ? 'pt-3' : 'pt-0']">
        <v-row no-gutters>
          <v-col cols="12">
            <v-col cols="12" v-if="id !== 0">
              <v-divider />
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" lg="6">
                  <div class="body-1 font-weight-medium">{{ dok.label }}</div>
                  <div class="body-2 grey--text" v-html="dok.deskripsi" />
                </v-col>
                <v-col cols="12" lg="6">
                  <v-row>
                    <v-col cols="12" lg="4">
                      <div class="body-2 grey--text">Status</div>
                      <v-chip :color="dok.file ? 'green' : 'red'" class="white--text">
                        {{ dok.file ? 'Sudah diunggah' : 'Belum diunggah' }}
                      </v-chip>
                    </v-col>
                    <v-col cols="12" lg="4">
                      <div class="body-2 grey--text">Aksi</div>
                      <v-btn depressed color="primary" @click="onUpload(dok)">
                        <v-icon left small>{{ dok.file && !dok.is_reupload ? 'mdi-pencil' : 'mdi-upload' }}</v-icon>
                        {{ dok.file && !dok.is_reupload ? 'Ubah' : 'Unggah' }}
                      </v-btn>
                    </v-col>
                    <v-col v-if="dok.file" cols="12" lg="4">
                      <div class="body-2 white--text">Berkas</div>
                      <v-btn
                        outlined
                        depressed
                        :color="dok.update ? 'orange' : 'primary'"
                        :href="dok.url"
                        :disabled="!dok.url"
                        target="_blank"
                      >
                        <v-icon left small>mdi-eye</v-icon>
                        Lihat Berkas
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-col>
        </v-row>
      </v-list-item>
    </v-list>
    <base-modal-full ref="modal" generalError title="Unggah Berkas Pendukung FSP" @save="onSave">
      <formulir-unggah
        ref="formulir"
        uimodel="card"
        :title="formulir.title"
        :format="formulir.format"
        :rules="formulir.rules"
        mode="upload"
      />
    </base-modal-full>
  </div>
</template>

<script>
import FormulirUnggah from '@components/form/Unggah';
import { mapActions } from 'vuex';

export default {
  name: 'Dokumen',
  components: { FormulirUnggah },
  props: {
    index: {
      type: Object,
      default: () => {},
    },
    edit: {
      type: Object,
      default: () => {},
    },
    biodata: {
      type: Object,
      default: () => {},
    },
    biodataEdit: {
      type: Object,
      default: () => {},
    },
    keyBerkasUpdates: {
      type: Array,
      default: () => [],
    },
    kVervalPsp: {
      type: Number,
      default: 1,
    },
    isEditBiodata: {
      type: Boolean,
      default: false,
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formulir: {},
    };
  },
  computed: {
    berkases() {
      let berkas = this.$getDeepObj(this.biodata, 'psp_biodata_berkases') || [];
      let result = {};

      for (const b of berkas) {
        result[this.$getDeepObj(b, 'm_profil_berkas_psp.singkat')] = {
          id: b.psp_biodata_berkas_id || '',
          file: b.file_berkas || '',
          url: b.url_berkas || '',
          is_reupload: b.is_reupload || false,
        };
      }

      return result;
    },

    dokumens() {
      return [
        {
          key: 'ijazah',
          label: 'Ijazah Pendidikan Terakhir',
          deskripsi: [
            'Catatan: ',
            '<ol style="padding-inline-start: 20px">',
            '<li>Pastikan nama pada pindaian ijazah yang diunggah sesuai dengan nama Anda</li>',
            '<li>Pastikan kualitas pindaian ijazah Anda jelas (tidak blur)</li>',
            '<li>Pastikan pindaian ijazah yang diunggah tidak dalam posisi terbalik untuk memudahkan verifikasi</li>',
            '<ol>',
          ].join(''),
          is_reupload: this.$getDeepObj(this.berkases, 'ijazah.is_reupload') || false,
          id: this.$getDeepObj(this.berkases, 'ijazah.id') || '',
          url: this.$getDeepObj(this.berkases, 'ijazah.url') || '',
          file: this.$getDeepObj(this.berkases, 'ijazah.file') || '',
          update: this.keyBerkasUpdates.includes(this.$getDeepObj(this.berkases, 'ijazah.id')),
        },
        {
          key: 'transkrip',
          label: 'Transkrip Nilai Pendidikan Terakhir',
          deskripsi: [
            'Catatan: ',
            '<ol style="padding-inline-start: 20px">',
            '<li>Pastikan nama pada pindaian transkrip nilai yang diunggah sesuai dengan nama Anda</li>',
            '<li>Pastikan kualitas pindaian transkrip nilai Anda jelas (tidak blur)</li>',
            '<li>Pastikan pindaian transkrip nilai yang diunggah tidak dalam posisi terbalik untuk memudahkan verifikasi</li>',
            '<ol>',
          ].join(''),
          is_reupload: this.$getDeepObj(this.berkases, 'transkrip.is_reupload') || false,
          id: this.$getDeepObj(this.berkases, 'transkrip.id') || '',
          url: this.$getDeepObj(this.berkases, 'transkrip.url') || '',
          file: this.$getDeepObj(this.berkases, 'transkrip.file') || '',
          update: this.keyBerkasUpdates.includes(this.$getDeepObj(this.berkases, 'transkrip.id')),
        },
        {
          key: 'rekomendasi',
          label: 'Surat Izin Atasan',
          deskripsi: [
            'Catatan: ',
            '<ol style="padding-inline-start: 20px">',
            '<li>Pastikan nama pada Surat Izin Atasan yang diunggah sesuai dengan nama Anda</li>',
            '<li>Pastikan Surat Izin Atasan yang diunggah tidak dalam posisi terbalik untuk memudahkan verifikasi</li>',
            '<ol>',
          ].join(''),
          is_reupload: this.$getDeepObj(this.berkases, 'rekomendasi.is_reupload') || false,
          id: this.$getDeepObj(this.berkases, 'rekomendasi.id') || '',
          url: this.$getDeepObj(this.berkases, 'rekomendasi.url') || '',
          file: this.$getDeepObj(this.berkases, 'rekomendasi.file') || '',
          update: this.keyBerkasUpdates.includes(this.$getDeepObj(this.berkases, 'rekomendasi.id')),
        },
        {
          key: 'tugas',
          label: 'SK Penempatan / SK Jabatan Terakhir Instansi Induk',
          deskripsi: [
            'Catatan: ',
            '<ol style="padding-inline-start: 20px">',
            '<li>Pastikan nama pada pindaian SK Penempatan / SK Jabatan Terakhir Instansi Induk yang diunggah sesuai dengan nama Anda</li>',
            '<li>Pastikan kualitas hasil pindaian SK Penempatan / SK Jabatan Terakhir Instansi Induk Anda jelas (tidak blur)</li>',
            '<li>Pastikan pindaian SK Penempatan / SK Jabatan Terakhir Instansi Induk yang diunggah tidak dalam posisi terbalik untuk memudahkan verifikasi</li>',
            '<ol>',
          ].join(''),
          is_reupload: this.$getDeepObj(this.berkases, 'tugas.is_reupload') || false,
          id: this.$getDeepObj(this.berkases, 'tugas.id') || '',
          url: this.$getDeepObj(this.berkases, 'tugas.url') || '',
          file: this.$getDeepObj(this.berkases, 'tugas.file') || '',
          update: this.keyBerkasUpdates.includes(this.$getDeepObj(this.berkases, 'tugas.id')),
        },
        {
          key: 'npwp',
          label: 'NPWP',
          deskripsi: [
            'Catatan: ',
            '<ol style="padding-inline-start: 20px">',
            '<li>Pastikan nama pada pindaian NPWP yang diunggah sesuai dengan nama Anda</li>',
            '<li>Pastikan kualitas hasil pindaian NPWP Anda jelas (tidak blur)</li>',
            '<li>Pastikan pindaian NPWP yang diunggah tidak dalam posisi terbalik untuk memudahkan verifikasi</li>',
            '<ol>',
          ].join(''),
          is_reupload: this.$getDeepObj(this.berkases, 'npwp.is_reupload') || false,
          id: this.$getDeepObj(this.berkases, 'npwp.id') || '',
          url: this.$getDeepObj(this.berkases, 'npwp.url') || '',
          file: this.$getDeepObj(this.berkases, 'npwp.file') || '',
          update: this.keyBerkasUpdates.includes(this.$getDeepObj(this.berkases, 'npwp.id')),
        },
        {
          key: 'rekening',
          label: 'Buku Rekening',
          deskripsi: [
            'Catatan: ',
            '<ol style="padding-inline-start: 20px">',
            '<li>Pastikan nama pada pindaian Buku Rekening yang diunggah sesuai dengan nama Anda</li>',
            '<li>Pastikan kualitas hasil pindaian Buku Rekening Anda jelas (tidak blur)</li>',
            '<li>Pastikan pindaian Buku Rekening yang diunggah tidak dalam posisi terbalik untuk memudahkan verifikasi</li>',
            '<ol>',
          ].join(''),
          is_reupload: this.$getDeepObj(this.berkases, 'rekening.is_reupload') || false,
          id: this.$getDeepObj(this.berkases, 'rekening.id') || '',
          url: this.$getDeepObj(this.berkases, 'rekening.url') || '',
          file: this.$getDeepObj(this.berkases, 'rekening.file') || '',
          update: this.keyBerkasUpdates.includes(this.$getDeepObj(this.berkases, 'rekening.id')),
        },
      ];
    },
  },
  methods: {
    ...mapActions('biodata', ['actions']),

    onUpload(dok) {
      if (!dok.is_reupload && !this.isEditBiodata) {
        this.$error('Data tidak bisa diubah karena telah diajukan');
        return;
      }

      if (!dok.is_reupload && this.index.tutup) {
        this.$error(this.index.tutup);
        return;
      }

      this.$set(this.formulir, 'id', dok.id);
      this.$set(this.formulir, 'is_reupload', dok.is_reupload || false);
      this.$set(this.formulir, 'label', dok.key);
      this.$set(this.formulir, 'title', dok.label);
      this.$set(this.formulir, 'format', `harus bertipe JPEG/JPG/PNG/PDF`);
      this.$set(this.formulir, 'rules', { format: 'JPEG|JPG|PNG|PDF', required: true });

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onSave() {
      const isReupload = this.formulir.is_reupload;
      const id = this.formulir.id;

      let formData = new FormData();
      formData.append('label', this.formulir.label);
      formData.append('file', this.$refs.formulir.form.file);

      this.actions({
        params: formData,
        update: this.$isObject(this.edit),
        action: `${isReupload ? `berkas-reupload/${id}` : 'berkas-insert'}`,
        upload: true,
      })
        .then(() => {
          this.$success('Berhasil diunggah');
          this.$refs.modal.dialog = false;
          this.$emit('reload');
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
